import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const ModalContent = styled(Text)`
  font-weight: 400;
  font-size: 14px;
  color: #5b5675;
`;

export const ModalSubHeading = styled(Text)`
  font-weight: 600;
  font-size: 14px;
  color: #5b5675;
  margin-bottom: 1rem;
`;

export const CueText = styled(Text)`
  color: #5b5675;
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  margin-top: 0.5rem;
  ${(props) => props.styles}

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 1rem;
    ${(props) => props.dWebStyles}
  }
`;

export const ModalHeading = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5rem;
  max-width: 90%;
  color: #040222;

  @media (min-width: 768px) {
    font-size: 1.25rem;
    line-height: 1.75rem;
    width: 100%;
  }

  ${(props) => props.styles}
`;

export const ChildrenWrapper = styled.div`
  width: 100%;
  @media (min-width: 767px) {
    ${(props) => props.dwebChildrenStyles}
  }
`;

export const MobileOverlay = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 10;
    background: ${(props) => props.backgroundColor};
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }
`;
